import loadable from '@loadable/component'

export const KeyHighlight = loadable(() => import('./KeyHighlight'))
export const KeyHighlights = loadable(() => import('./KeyHighlights'))
export type {
  KeyHighlightLinkProps,
  KeyHighlightImageProps,
  KeyHighlightProps
} from './KeyHighlight'
export type { KeyHighlightsProps } from './KeyHighlights'
